import React, { useEffect, useState } from 'react';

import Icon from 'components/icons';
import { PanelCheckList } from 'components/panelCheckList';
import I18n from 'components/translate/I18n';
import { AuthService } from 'modules/auth';
import {
  ClassService,
  ClassServiceUtil,
  DefaultClassUtil
} from 'modules/classManager';
import PropTypes from 'prop-types';

const formatItem = (item) => {
  return (
    <div className="module-selection__page-list-panel__item">
      <span className="module-selection__page-list-panel__name">
        {item.name}
      </span>
      <p className="module-selection__page-list-panel__type">
        {!AuthService.isEditor() && (
          <>
            {item.totalUsers}{' '}
            <I18n label="general.student" data={{ count: item.totalUsers }} />
            <span>
              <Icon prefix="far" iconName="users" />
            </span>
          </>
        )}
      </p>
    </div>
  );
};

const ClassSelectionStep = ({ onChange, moduleClasses }) => {
  const [isLoadingClasses, setIsLoadingClasses] = useState(true);
  const [classList, setClassList] = useState([]);
  const [checkedList, setCheckedList] = useState([]);

  const onChangeCheckedList = (classes) => {
    setCheckedList(classes);
    onChange(classes);
  };

  const formatItems = (classList) => {
    return (classList || []).map((item) => ({
      ...item,
      value: item.id,
      labelValue: item.name,
      checked: (checkedList || []).includes(item.id)
    }));
  };

  const formatSubheader = (item) => (
    <span className="module-selection__page-list-panel__subheader">
      <span>{item.name}</span>
      <span className="module-selection__page-list-panel__subheader__info">
        <I18n
          label="content_list.content_duplication.n_classes"
          data={{ classes: classList.length, count: classList.length }}
        />
      </span>
    </span>
  );

  useEffect(() => {
    const getDuplicationPages = async () => {
      const response = await ClassService.getClasses();

      const classesMap = (response || []).map((item) => item.id);
      const totalUsersList = !AuthService.isEditor()
        ? await ClassService.getTotalUsersByClasses(classesMap)
        : [];

      setIsLoadingClasses(false);

      const totalUsersMap =
        ClassServiceUtil.parseTotalUsersListToMap(totalUsersList);
      const classes = (response || []).map((item) => {
        item.name = DefaultClassUtil.getName(item.name) || '';
        item.totalUsers = totalUsersMap.get(item.id);
        return item;
      });

      const intersectClassItems = classes.reduce((accumulator, classItem) => {
        if (moduleClasses.includes(classItem.id)) {
          accumulator.push(classItem.id);
        }

        return accumulator;
      }, []);

      setClassList(classes);
      onChangeCheckedList(intersectClassItems);
    };

    getDuplicationPages();
  }, []);

  return (
    <div>
      <div className="module-selection__page-list">
        <h3 className="module-selection__page-list__modules_question">
          <I18n label="content_list.content_duplication.class_list" />
        </h3>
      </div>
      <PanelCheckList
        name="duplicationCandidates"
        className="module-selection__page-list-panel"
        loading={isLoadingClasses}
        value={classList}
        formatItems={formatItems}
        formatItem={formatItem}
        formatSubheader={formatSubheader}
        onChange={(event) => onChangeCheckedList(event.target.value)}
      />
    </div>
  );
};

ClassSelectionStep.propTypes = {
  onChange: PropTypes.func.isRequired,
  moduleClasses: PropTypes.array
};

export default ClassSelectionStep;
